<template>
  <div>
    <div class="container relative-position" style="min-height: 95vh">
      <div v-if="resource && loaded">
        <div class="page-tool-bar">
          <div class="text-center">
            <q-btn
              class="on-left" flat small round :color="azOpen ? 'info' : ''" @click="azOpen = !azOpen"
            >
              <q-tooltip>
                Show Alphabet Filters
              </q-tooltip>
              <q-icon name="sort_by_alpha" />
            </q-btn>
          </div>
          <az-bar :resource="resource" v-if="azOpen"></az-bar>
        </div>
        <select-layout-table :resource="resource" ref="table"></select-layout-table>
        <q-btn
          color="primary"
          @click="save"
          class="full-width"
          push size="lg"
          v-close-overlay
        >Save</q-btn>
        <q-btn
          flat color="negative"
          full class="q-mt-lg"
          @click="close"
          v-close-overlay
        >Cancel</q-btn>
      </div>
      <div class="row">
        <div class="col-12">
          <q-pagination
            class="text-center justify-center"
            :value="pagination.page"
            color="secondary"
            :min="1"
            :max="maxPage"
            :max-pages="15"
            boundary-numbers
            boundary-links
            @change="changePage"
          />
        </div>
      </div>
      <q-inner-loading :visible="!loaded" />
    </div>
  </div>
</template>
<script>

import { extend } from 'quasar'

export default {
  name: 'SelectList',
  props: {
    resource: {
      type: String,
      required: true
    },
    columnField: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      azOpen: false,
      loaded: false,
      loading: true,
      ready: false,
      isModalOpen: false,
      filter: '',
      trashed: false,
      pagination: { page: 1 }
    }
  },
  methods: {
    handleRefresh () {
      this.request({
        pagination: {},
        filter: ''
      })
      this.$refs.table.selectedRows = []
    },
    async request ({pagination = {}}) {
      // // console.log(pagination)
      this.loading = true
      try {
        await this.$store.dispatch(`${this.resource}/paginate`, {
          client: this.$axios,
          pagination,
          trashed: this.trashed ? 1 : null
        })
        this.loading = false
        return Promise.resolve()
      } catch (e) {
        this.loading = false
        return Promise.resolve()
      }
    },
    async changePage (page) {
      const pagination = extend(true, this.pagination, {page})
      await this.request({pagination})
    },
    close () {
      this.handleRefresh()
    },
    save () {
      // console.log('Add Rows:')
      this.$emit('add', this.$refs.table.selectedRows)
      this.handleRefresh()
    }
  },
  computed: {
    maxPage () {
      return Math.ceil(this.pagination.rowsNumber / this.pagination.rowsPerPage || 1)
    },
    clientRoute () { return this.$store.state[this.resource].clientRoute }
  },
  async mounted () {
    // once mounted, we need to trigger the initial server data fetch
    await this.request({
      pagination: this.pagination
    })
    this.$nextTick(() => {
      this.loaded = true
      this.ready = true
    })
  }
}
</script>
